<template>
    <div class="coupon-popup">
        <van-nav-bar title="优惠券" left-arrow @click-left="onClickLeft" fixed placeholder style="z-index: 3;" />
        <div class="popup-content">
            <div v-if="couponList.length === 0" class="empty-state">
                <van-empty description="暂无优惠券" />
            </div>
            <div v-else class="coupon-list">
                <div v-for="item in couponList" :key="item.id" class="coupon-item" :class="{
                    'coupon-disabled': item.status !== 1,
                    'coupon-active': item.status === 1
                }">
                    <!-- 左侧装饰条 -->
                    <div class="coupon-left-bar" :class="'status-' + item.status"></div>

                    <!-- 优惠券内容 -->
                    <div class="coupon-content">
                        <div class="coupon-left">
                            <div class="coupon-image-wrapper">
                                <img :src="item.coupon_image" alt="优惠券" class="coupon-image" />
                                <div class="coupon-image-overlay" v-if="item.status !== 1"></div>
                            </div>
                        </div>
                        <div class="coupon-right">
                            <div class="coupon-header">
                                <div class="coupon-name-wrapper">
                                    <div class="coupon-name">{{ item.coupon_name }}</div>
                                    <div class="coupon-type-badge">{{ item.coupon_type_text }}</div>
                                </div>
                            </div>
                            <div class="coupon-amount-wrapper">
                                <div class="coupon-amount">
                                    <span class="amount-symbol">¥</span>
                                    <span class="amount-value">{{ item.coupon_discount_amount }}</span>
                                </div>
                                <div class="coupon-condition">
                                    满{{ item.coupon_min_amount }}元可用
                                </div>
                            </div>
                            <div class="coupon-footer">
                                <div class="coupon-time">
                                    <van-icon name="clock-o" class="time-icon" />
                                    <span>{{ formatTime(item.start_time) }} 至 {{ formatTime(item.end_time) }}</span>
                                </div>
                                <div class="coupon-status">
                                    <span class="status-badge" :class="'status-' + item.status">
                                        {{ item.status_text }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { couponList } from '@/api/course';
export default {
    name: 'viewCoupon',
    data() {
        return {
            couponList: [],
        }
    },
    created() {
        let query = this.$route.query;
        console.log(query);
        this.getCouponList(query);
    },
    methods: {
        getCouponList(obj) {
            console.log(obj);
            couponList(obj).then(res => {
                if (res.code == 1) {
                    this.couponList = res.data.list || [];
                } else {
                    this.$toast.fail(res.msg || '获取优惠券列表失败');
                }
            }).catch(err => {
                this.$toast.fail('获取优惠券列表失败');
                console.error(err);
            });
        },
        formatTime(timeStr) {
            if (!timeStr) return '';
            return timeStr.split(' ')[0];
        },
    }
}
</script>

<style lang="less" scoped>
.coupon-popup {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f7f8fc;
}

.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--base-px-16) var(--base-px-16) var(--base-px-12);
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    position: sticky;
    top: 0;
    z-index: 10;
}

.header-title {
    font-size: var(--base-px-18);
    font-weight: 600;
    color: #333;
}

.close-icon {
    font-size: var(--base-px-20);
    color: #666;
    cursor: pointer;
}

.popup-content {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    padding: var(--base-px-12);
}

.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.coupon-list {
    display: flex;
    flex-direction: column;
    gap: var(--base-px-16);
}

.coupon-item {
    position: relative;
    background: #fff;
    border-radius: var(--base-px-12);
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    &.coupon-active {
        border: 1px solid rgba(24, 144, 255, 0.2);
    }

    &.coupon-disabled {
        opacity: 0.65;
        filter: grayscale(0.3);

        &:hover {
            transform: none;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        }
    }
}

// 左侧装饰条
.coupon-left-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);

    &.status-1 {
        background: linear-gradient(180deg, #1890ff 0%, #096dd9 100%);
    }

    &.status-2 {
        background: linear-gradient(180deg, #fa8c16 0%, #d46b08 100%);
    }

    &.status-3 {
        background: linear-gradient(180deg, #52c41a 0%, #389e0d 100%);
    }

    &.status-4 {
        background: linear-gradient(180deg, #ff4d4f 0%, #cf1322 100%);
    }
}

.coupon-content {
    display: flex;
    margin-left: 4px;
}

.coupon-left {
    width: var(--base-px-110);
    flex-shrink: 0;
    background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--base-px-16);
    position: relative;
}

.coupon-image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.coupon-image {
    width: 100%;
    height: auto;
    max-height: var(--base-px-90);
    object-fit: contain;
    border-radius: var(--base-px-6);
    transition: transform 0.25s;
}

.coupon-item:hover .coupon-image {
    transform: scale(1.05);
}

.coupon-image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    border-radius: var(--base-px-6);
    pointer-events: none;
}

.coupon-right {
    flex: 1;
    padding: var(--base-px-16);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: var(--base-px-120);
}

.coupon-header {
    margin-bottom: var(--base-px-12);
}

.coupon-name-wrapper {
    display: flex;
    align-items: center;
    gap: var(--base-px-8);
    flex-wrap: wrap;
}

.coupon-name {
    font-size: var(--base-px-17);
    font-weight: 600;
    color: #0f172a;
    line-height: 1.4;
    flex: 1;
    min-width: 0;
}

.coupon-type-badge {
    font-size: var(--base-px-11);
    color: #475569;
    background: #f1f5f9;
    padding: var(--base-px-4) var(--base-px-10);
    border-radius: var(--base-px-12);
    white-space: nowrap;
    font-weight: 500;
}

.coupon-amount-wrapper {
    margin-bottom: var(--base-px-12);
}

.coupon-amount {
    display: flex;
    align-items: baseline;
    margin-bottom: var(--base-px-6);
}

.amount-symbol {
    font-size: var(--base-px-16);
    color: #ff4d4f;
    font-weight: 600;
    margin-right: var(--base-px-2);
}

.amount-value {
    font-size: var(--base-px-28);
    color: #ff4d4f;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.5px;
}

.coupon-condition {
    font-size: var(--base-px-13);
    color: #64748b;
    font-weight: 400;
}

.coupon-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: var(--base-px-12);
    border-top: 1px solid #f1f5f9;
}

.coupon-time {
    display: flex;
    align-items: center;
    gap: var(--base-px-4);
    font-size: var(--base-px-12);
    color: #94a3b8;
    flex: 1;
}

.time-icon {
    font-size: var(--base-px-14);
    color: #cbd5e1;
}

.coupon-status {
    display: flex;
    justify-content: flex-end;
}

.status-badge {
    font-size: var(--base-px-12);
    padding: var(--base-px-5) var(--base-px-10);
    border-radius: var(--base-px-12);
    font-weight: 500;
    white-space: nowrap;

    &.status-1 {
        background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
        color: #0958d9;
        border: 1px solid rgba(24, 144, 255, 0.2);
    }

    &.status-2 {
        background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
        color: #d46b08;
        border: 1px solid rgba(250, 140, 22, 0.2);
    }

    &.status-3 {
        background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);
        color: #389e0d;
        border: 1px solid rgba(82, 196, 26, 0.2);
    }

    &.status-4 {
        background: linear-gradient(135deg, #fff1f0 0%, #ffccc7 100%);
        color: #cf1322;
        border: 1px solid rgba(255, 77, 79, 0.2);
    }
}
</style>